import { UiWrapper } from '@coinscrap/webapp-core';

const LoadingScreen = () => {
	UiWrapper.use().useLoading(true, { loadingMessage: 'Cargando' });
	return null;
};

export default LoadingScreen;
